<template>
  <div v-if="$whitelabel.hasNewsletterOptin">
    <Separator />
    <div class="field content">
      <div class="is-flex u-flex-wrap">
        <b-checkbox v-model="optinNewsletter" @input="optInTrigger" native-value="newsletter" class="mr-4">
          {{ $t('payment.newsletteroptin.subscribe_newsletter') }}
        </b-checkbox>
        <button class="button is-text mt-4" @click="isOptinOpen = !isOptinOpen" aria-controls="optinInfo">{{ $t('payment.newsletteroptin.agreement_info') }}</button>
      </div>

      <b-collapse :open.sync="isOptinOpen" aria-id="optinInfo" class="mt-4">
        <div class="notification mb-5">
          <div class="content">
            <i18n path="payment.newsletteroptin.agreement" tag="p">
              <router-link to="/datenschutz" target="_blank">{{ $t('payment.newsletteroptin.agreement_privacy_policy') }}</router-link>
            </i18n>

            <i18n path="payment.newsletteroptin.agreement_unsubscribe_link" tag="p">
              <a href="mailto:info@we-are.travel">info@we-are.travel</a>
            </i18n>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import Separator from '@/components/Separator'
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'NewsletterOptin',
  components: {
    Separator,
  },
  data() {
    return {
      isOptinOpen: false,
      optinNewsletter: false,
    }
  },
  computed: {
    ...mapGetters({
      newsletter: '$_checkout/newsletterOptin',
    }),
  },
  methods: {
    ...mapActions({
      change: '$_checkout/setOptinOptions',
    }),
    optInTrigger() {
      this.change({newsletter: this.optinNewsletter})
    },
  },
  mounted() {
    this.optinNewsletter = this.newsletter
  },
}
</script>

<style scoped lang="sass"></style>
